module.exports = __webpack_public_path__ + "static/img/bpo.717d9f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jianjie/bpo.png
// module id = UKqa
// module chunks = 171